import React, { Component } from 'react';
import { saveAs } from 'file-saver';
import _ from 'lodash';

var JSZip = require('jszip');
var JSZipUtils = require('jszip-utils');

export default class AttachmentList extends Component {
  constructor(props){
    super(props)

    this.renderRow = this.renderRow.bind(this);
    this.zipAndDownload = this.zipAndDownload.bind(this);
    this.zipAndDownloadAll = this.zipAndDownloadAll.bind(this);
  }

  renderRow(attachment, index){
    return (
      <li key={index}>
        <a href={attachment.attributes.url} target="_blank">
          {attachment.attributes.document_file_name}
        </a>
      </li>
    )
  }

  // zipAndDownload(){
  //   var zip = new JSZip();

  //   zip.file("Hello.txt", "Hello World\n");
  //   var img = zip.folder("images"); //images is the folder which will be zip

  //   img.file("smile.gif", imgData, {base64: true});

  //   zip.generateAsync({type:"blob"}).then(function(content) {
  //       saveAs(content, "example.zip");
  //   });
  // }

  zipAndDownload(){
    var zip = new JSZip();
    var count = 0;
    var zipFilename = "archived.zip";
    var total_count = this.props.attachments.length;

    this.props.attachments.forEach(function(attachment){
      var url = attachment.attributes.url
      url = decodeURI(url)

      var filename = url.substr(url.lastIndexOf("/")+1);
      filename = filename.split("?")[0];

      JSZipUtils.getBinaryContent(url, function (err, data) {
        if(err) {
          throw err; // or handle the error
        }
        zip.file(filename, data, {binary:true});

        count++;
        if (count == total_count) {
          zip.generateAsync({type:'blob'}).then(function(content) {
            saveAs(content, zipFilename);
          });
        }
      });
    });
  }

  zipAndDownloadAll(){
    var zip = new JSZip();
    var count = 0;
    var zipFilename = "archived.zip";
    var total_count = this.props.attachments.length;
    var pdf_file_url = decodeURI(this.props.pdf_file.attributes.url);
    var pdf_file_name = this.props.document.attributes.topic + ".pdf";

    this.props.attachments.forEach(function(attachment){
      var url = attachment.attributes.url
      url = decodeURI(url)

      var filename = url.substr(url.lastIndexOf("/")+1);
      filename = filename.split("?")[0];

      JSZipUtils.getBinaryContent(url, function (err, data) {
        if(err) {
          throw err; // or handle the error
        }
        zip.file(filename, data, {binary:true});

        count++;
        if (count == total_count) {
          // main document
          console.log(pdf_file_url);
          JSZipUtils.getBinaryContent(pdf_file_url, function (err, data) {
            if(err) {
              throw err; // or handle the error
            }
            zip.file(pdf_file_name, data, {binary:true});

            zip.generateAsync({type:'blob'}).then(function(content) {
              saveAs(content, zipFilename);
            });
          });
        }
      });
    });
  }

  render(){
    let hasItems = this.props.attachments && this.props.attachments.length > 0
    return (
      <div>
        <ul className='m-0 ul-group-list'>
          {!_.isEmpty(this.props.attachments) && _.map(this.props.attachments, this.renderRow)}
          {!hasItems && <li>No items</li>}
          <li className='mt-3'><a href="javascript:void(0);" onClick={this.zipAndDownload}>ดาวน์โหลดเอกสารแนบทั้งหมด</a></li>
          <li><a href="javascript:void(0);" onClick={this.zipAndDownloadAll}>ดาวน์โหลดหนังสือพร้อมเอกสารแนบทั้งหมด</a></li>
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/documents/actions/AttachmentList.js